import(/* webpackMode: "eager" */ "/tmp/8de38e4a1419f75/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de38e4a1419f75/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de38e4a1419f75/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de38e4a1419f75/src/components/Header.tsx");
